import { SHOPPING_LISTS_ENDPOINTS } from "./endpoints";
import type { SupportedShoppingSupermarket } from "./types";
import { apiRequestWithData } from "../shared";

export async function getSupportedShoppingSupermarkets(): Promise<SupportedShoppingSupermarket[]> {
  return apiRequestWithData<SupportedShoppingSupermarket[]>(SHOPPING_LISTS_ENDPOINTS.GET_SUPERMARKETS);
}

export default getSupportedShoppingSupermarkets;
